import { render, staticRenderFns } from "./PdfDocuments.vue?vue&type=template&id=5b1d201c&scoped=true"
import script from "./PdfDocuments.vue?vue&type=script&lang=js"
export * from "./PdfDocuments.vue?vue&type=script&lang=js"
import style0 from "./PdfDocuments.vue?vue&type=style&index=0&id=5b1d201c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1d201c",
  null
  
)

export default component.exports